import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/icons/Logo.svg";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";

export function Header({
  showSignIn = false,
  showSignUp = false,
  isProvider = false,
}) {
  const {styles, tenantProfile} = useApp();
  
  return (
    <div className="px-10 py-4 bg-white/[0.64] backdrop-blur-[27px] border-b border-black/10 justify-between items-center flex">
      <div className="w-24 h-7 justify-center items-center flex">
        {styles?.logo ? <SignedUrlImage s3Key={styles?.logo} bucket={tenantProfile?.assets_bucket} alt="logo" className="max-w-[176px] max-h-[40px]" /> : <Logo />}
      </div>
      <div className="justify-start items-start gap-3 flex">
        {showSignIn && (
          <Link
            to={isProvider ? "/provider/login" : "/login"}
            className="px-4 py-2 !rounded-full bg-primary justify-center items-center gap-2.5 flex"
          >
            <div className="text-text-secondary text-sm font-medium leading-normal">
              Log in
            </div>
          </Link>
        )}

        {showSignUp && (
          <Link
            to={isProvider ? "/provider/register" : "/register"}
            className="px-4 py-2 bg-primary rounded-md justify-center items-center gap-2.5 flex"
          >
            <div className="text-text-secondary text-sm font-medium leading-normal">
              Sign up
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
